import { useState } from "react";
import useReveal from "../hooks/useReveal";
import "./Contact.css";
import { axiosInstance } from "../config";
import {
  FaInstagram,
  FaXTwitter,
  FaLinkedinIn,
  FaFacebook,
} from "react-icons/fa6";

const INFO = [
  {
    icon: "✉",
    label: "Email",
    value: "info@cubextechnology.com",
    href: "mailto:info@cubextechnology.com",
  },
  {
    icon: "📞",
    label: "Phone",
    value: "+91 92651 89542",
    href: "tel:+919265189542",
  },
  {
    icon: "📞",
    label: "Phone",
    value: "+91 94283 23600",
    href: "tel:+919428323600",
  },
  {
    icon: "📍",
    label: "Location",
    value: "B-304 Purva Gold, Gotri, Vadodara 390021, India",
    href: "#",
  },
  { icon: "🕐", label: "Hours", value: "Mon–Fri, 9 AM – 6 PM IST", href: "#" },
];

const SERVICES_OPTIONS = [
  "Software Development",
  "Mobile App Development",
  "Hire a R esource",
  "Digital Marketing",
  "Maintenance",
  "Graphics Design",
  "Other",
];

export default function Contact() {
  useReveal();
  const [form, setForm] = useState({
    name: "",
    companyName: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [service, setService] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [sent, setSent] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Name is required";
    if (!companyName.trim()) newErrors.companyName = "Company name is required";
    if (!email.trim()) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(email)) newErrors.email = "Invalid email";
    if (!message.trim()) newErrors.message = "Message is required";
    return newErrors;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});
    setLoading(true);

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", mobile);
    formData.append("details", message);
    formData.append("service", service);
    formData.append("message", message);
    formData.append("company_name", companyName);

    try {
      const res = await axiosInstance.post("contact", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      if (res.data.message === "Message Succesfully sent...") {
        setSent(true);
        setName("");
        setEmail("");
        setMessage("");
        setMobile("");
        setService("");
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const handleReset = () => {
    setSent(false);
    setName("");
    setEmail("");
    setMessage("");
    setMobile("");
    setService("");
    setErrors({});
  };

  const socials = [
    { icon: <FaXTwitter />, url: "https://x.com/CubexTechnology" },
    {
      icon: <FaLinkedinIn />,
      url: "https://www.linkedin.com/company/cubextechnology/posts/?feedView=all",
    },
    {
      icon: <FaInstagram />,
      url: "https://www.instagram.com/cubextechnology?igsh=NHQ0YWV1N24zZXcw",
    },
    {
      icon: <FaFacebook />,
      url: "https://www.facebook.com/profile.php?id=61567936015225",
    },
  ];

  return (
    <div className="contact-page">
      {/* PAGE HERO */}
      <div className="page-hero">
        <span className="ph-eye">Get in Touch</span>
        <h1 className="ph-title">
          Let's Build Something <span className="g">Together</span>
        </h1>
        <p className="ph-sub">
          Have a project in mind? Tell us about it and we'll get back to you
          within 24 hours with a tailored plan.
        </p>
      </div>

      <section className="contact-sect">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-left rl">
              <h3 className="contact-left__title">Contact Information</h3>
              <p className="contact-left__sub">
                Reach us through any channel and our team will respond promptly.
              </p>

              <div className="contact-info">
                {INFO.map((item) => (
                  <a key={item.label} href={item.href} className="c-item">
                    <div className="c-icon">{item.icon}</div>
                    <div>
                      <div className="c-label">{item.label}</div>
                      <div className="c-value">{item.value}</div>
                    </div>
                  </a>
                ))}
              </div>

              <div className="contact-socials">
                {socials.map((s) => (
                  <a
                    key={s.icon}
                    href={s.url}
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {s.icon}
                  </a>
                ))}
              </div>
            </div>

            <div className="rr">
              {sent ? (
                <div className="success-box">
                  <div className="success-icon">✦</div>
                  <h3>Message Sent!</h3>
                  <p>
                    Thank you for reaching out. We'll be in touch within 24
                    hours with a tailored response.
                  </p>
                  <button className="btn-ghost" onClick={handleReset}>
                    Send Another Message
                  </button>
                </div>
              ) : (
                <form
                  className="contact-form"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <h3 className="form-title">Send a Message</h3>

                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Your Name *</label>
                      <input
                        className={`form-input${errors.name ? " err" : ""}`}
                        type="text"
                        name="name"
                        placeholder="John Doe"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                      {errors.name && (
                        <span className="form-err">{errors.name}</span>
                      )}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Your Company Name *</label>
                      <input
                        className={`form-input${errors.companyName ? " err" : ""}`}
                        type="text"
                        name="companyName"
                        placeholder="Company Name"
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                      />
                      {errors.companyName && (
                        <span className="form-err">{errors.companyName}</span>
                      )}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label">Email Address *</label>
                      <input
                        className={`form-input${errors.email ? " err" : ""}`}
                        type="email"
                        name="email"
                        placeholder="john@company.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      {errors.email && (
                        <span className="form-err">{errors.email}</span>
                      )}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Phone Number</label>
                      <input
                        className="form-input"
                        type="tel"
                        name="phone"
                        placeholder="+91 98765 43210"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Service Interested In</label>
                    <select
                      className="form-input form-select"
                      name="service"
                      value={service}
                      onChange={(e) => setService(e.target.value)}
                    >
                      <option value="">Select a service…</option>
                      <option value="Software Development">
                        Software Development
                      </option>
                      <option value="Mobile App Development">
                        Mobile App Development
                      </option>
                      <option value="Hire a Resource">Hire a Resource</option>
                      <option value="Digital Marketing">
                        Digital Marketing
                      </option>
                      <option value="Maintenance">Maintenance</option>
                      <option value="Graphics Design">Graphics Design</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Your Message *</label>
                    <textarea
                      className={`form-input form-textarea${errors.message ? " err" : ""}`}
                      name="message"
                      rows={5}
                      placeholder="Tell us about your project, goals, and timeline…"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                    {errors.message && (
                      <span className="form-err">{errors.message}</span>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="btn-primary submit-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <span className="btn-dots">
                        <span />
                        <span />
                        <span />
                      </span>
                    ) : (
                      <>Send Message ✦</>
                    )}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      <div className="map-band">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.1347011918715!2d73.13821717529288!3d22.310744879679074!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa7ef4825c9ed5397%3A0xfc99267ffc6c79ee!2sCubex%20Technology!5e0!3m2!1sen!2sin!4v1732524096907!5m2!1sen!2sin"
          width="100%"
          height="450"
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
}
